import { useCallback } from 'react';
import MunicipalPortalAAppService from 'application/platform/municipal-portal-service';
import { useUnidadeSaudeDetailsDispatch } from './unidade-saude-details-context';
import { ACTION_TYPES } from './unidade-saude-details-reducer';

export const useUnidadeSaudeDetailsController = () => {
    const dispatch = useUnidadeSaudeDetailsDispatch();

    const loadUnidadeSaudeDetails = useCallback(async (id: number) => {
        try {
            dispatch({ type: ACTION_TYPES.setLoading, payload: true });
            dispatch({ type: ACTION_TYPES.setError, payload: null });

            const response = await MunicipalPortalAAppService.getUnidadeSaude(id);

            dispatch({ type: ACTION_TYPES.setUnidadeSaudeDetails, payload: response });
        } catch (error) {
            console.error('Error loading unidade de saúde details:', error);
            dispatch({ type: ACTION_TYPES.setError, payload: 'Erro ao carregar detalhes da unidade de saúde' });
            dispatch({ type: ACTION_TYPES.setUnidadeSaudeDetails, payload: null });
        } finally {
            dispatch({ type: ACTION_TYPES.setLoading, payload: false });
        }
    }, [dispatch]);

    const clearUnidadeSaudeDetails = useCallback(() => {
        dispatch({ type: ACTION_TYPES.setUnidadeSaudeDetails, payload: null });
        dispatch({ type: ACTION_TYPES.setError, payload: null });
    }, [dispatch]);

    return {
        loadUnidadeSaudeDetails,
        clearUnidadeSaudeDetails,
    };
};
